import CohesionWrapper from './CohesionWrapper';

export default CohesionWrapper;
